import React, { useRef } from 'react'
import { Carousel, Button } from 'antd'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'

export const MediaDisplay = ({ media }) => {
  const carouselRef = useRef()
  if (!media || !media.items || media.items.length === 0) return null

  const { type, items } = media

  const SmartVideoPlayer = ({ url, width = 640, height = 360 }) => {
    // Hàm kiểm tra link có phải là file video
    const isVideoFile = (link) => {
      return /\.(mp4|webm|ogg)(\?.*)?$/i.test(link)
    }

    // Hàm lấy ID video YouTube từ link
    const getYouTubeId = (link) => {
      const regExp = /(?:youtube\.com\/.*v=|youtu\.be\/)([^&?/]+)/
      const match = link.match(regExp)
      return match ? match[1] : null
    }

    // Hàm lấy ID video TikTok từ link
    const getTikTokId = (link) => {
      const regExp = /tiktok\.com\/@[\w.-]+\/video\/(\d+)/
      const match = link.match(regExp)
      return match ? match[1] : null
    }

    // Xử lý theo loại link
    if (isVideoFile(url)) {
      return (
        <video width={width} height={height} controls>
          <source src={url} />
          Trình duyệt của bạn không hỗ trợ video.
        </video>
      )
    }

    const ytId = getYouTubeId(url)
    if (ytId) {
      const ytEmbed = `https://www.youtube.com/embed/${ytId}`
      return (
        <iframe
          width={width}
          height={height}
          src={ytEmbed}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="YouTube video player"
        />
      )
    }

    const tiktokId = getTikTokId(url)
    if (tiktokId) {
      const tiktokEmbed = `https://www.tiktok.com/embed/v2/${tiktokId}`
      return <iframe width={width} height={height} src={tiktokEmbed} frameBorder="0" allowFullScreen title="TikTok video player" />
    }

    // Không hỗ trợ link
    return <div>Không hỗ trợ định dạng video hoặc link không hợp lệ.</div>
  }

  if (type === 'IMAGE') {
    return (
      <div className="position-relative">
        <img src={items[0].url} alt={`image-${items[0].url}`} className="w-100 rounded" style={{ maxHeight: 300, objectFit: 'cover' }} />
      </div>
    )
  }
  return null
}
